// extracted by mini-css-extract-plugin
export default {"wrapper":"modal_wrapper__4ZOOA","bg":"modal_bg__UJE+t","modal-bg":"modal_modal-bg__asyTj","modal":"modal_modal__ZWWnt"};